import { funFacts } from '../data/portfolioData';

export const Fun = ({ isVisible }) => (
  <section id="fun" className={`fun ${isVisible ? 'fade-in' : ''}`}>
    <div className="sec-head">
      <span className="kicker">◆ 06 · B-SIDES</span>
      <h2>Off the <em>clock</em>.</h2>
    </div>

    <div className="fun-grid">
      {funFacts.map((f) => (
        <div key={f.title} className="fun-tile" style={{ '--ft': f.color }}>
          <div className="fun-icon">
            <span style={{ fontSize: '36px', lineHeight: 1 }}>{f.icon}</span>
          </div>
          <div className="fun-k">{f.title}</div>
          <div className="fun-v">{f.body}</div>
        </div>
      ))}
    </div>
  </section>
);
